import styled from 'styled-components'

export const StyledPromoBadge = styled.div`
  height: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;

export const StyledSaleBadge = styled.div<{ buttonConfig: any; labelConfig: any; }>`
  display: flex;
  flex-direction: column;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  cursor: ${props => props?.buttonConfig?.onClick?.url ? 'pointer' : 'default' };
  align-self: stretch;
  border: ${props => props?.buttonConfig?.style?.border || '0'};
  border-radius: 4px;
  background: var(--car-parts-alerts-danger-20-fbd-6-d-4, ${props => props?.buttonConfig?.style?.background?.color || '#FBD6D4'});

`;

export const BadgeLabel = styled.div<{ labelConfig: any; }>`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;

  b {
    color: var(--CTA-Button-Primary-Text, ${props => props?.labelConfig?.style?.font?.color || '#282832'});
    text-align: center;
    /* Text/Body/1 (12)/600 */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: ${props => props?.labelConfig?.style?.font?.weight || '600'};
    line-height: 165%; /* 19.8px */
  }
`;

export const BadgeIcon = styled.div<{ iconConfig: any; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 20px;
  padding: ${props => props?.iconConfig?.style?.padding || '0'};

  svg {
    max-width: 100%;
    max-height: 100%;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const BadgeContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
`;
